import * as React from 'react';
import { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider';

import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';


// material
import { alpha } from '@mui/material/styles';
import { MenuItem, ListItemIcon, ListItemText } from '@mui/material';
// components
import MenuPopover from './menupop';
import { Stack } from '@mui/material';


import firebase from "./firebase";


const LANGS = [
  {
    value: 'it',
    label: 'Italiano',
    icon: '/icons/ic_flag_fr.svg'
  },
  {
    value: 'eng',
    label: 'English',
    icon: '/icons/ic_flag_en.svg'
  },

];

function TabPanel(props) {
  const { children, value, index, ...other } = props;





  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function App() {
  const [value, setValue] = useState(0);
  const [antipasti, setAntipasti] = useState([]);
  const [primi, setPrimi] = useState([]);
  const [secondi, setSecondi] = useState([]);
  const [contorni, setContorni] = useState([]);
  const [bevande, setBevande] = useState([]);
  const [dolci, setDolci] = useState([]);
  const [rossi, setRossi] = useState([]);
  const [bianchi, setBianchi] = useState([]);
  const [rosati, setRosati] = useState([]);
  const [bollicine, setBollicine] = useState([]);
  const [distillati, setDistillati] = useState([]);
  const [lingua, setLingua] = useState("it")

  const anchorRef = useRef(null);

  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  function handleClose(key) {
    console.log(key)
    setOpen(false);
    if (key == "it" || key == "eng") {
      setLingua(key)

    }
  };


  function get(lingua) {
    if (lingua == "it") {
      firebase.database().ref("/")
        .once('value')
        .then(snapshot => {

          //Antipasti
          let antipasti = {};
          if (snapshot.val().antipasti) {
            antipasti.titoli = snapshot.val()?.antipasti.titoli.split("||");
            antipasti.descrizioni = snapshot.val()?.antipasti.descrizioni.split("||");
            antipasti.prezzi = snapshot.val()?.antipasti.prezzi.split("||");
            antipasti.allergeni = snapshot.val()?.antipasti?.allergeni?.split("||");

          }
          else {
            antipasti.titoli = "|";
          }
          //Antipasti


          //Primi
          let primi = {};
          if (snapshot.val().primi) {

            primi.titoli = snapshot.val()?.primi.titoli.split("||");
            primi.descrizioni = snapshot.val()?.primi.descrizioni.split("||");
            primi.prezzi = snapshot.val()?.primi.prezzi.split("||");
            primi.allergeni = snapshot.val()?.primi?.allergeni?.split("||");

          }
          else {
            primi.titoli = "|";
          }
          //Primi


          //Secondi
          let secondi = {};
          if (snapshot.val().secondi) {

            secondi.titoli = snapshot.val()?.secondi.titoli.split("||");
            secondi.descrizioni = snapshot.val()?.secondi.descrizioni.split("||");
            secondi.prezzi = snapshot.val()?.secondi.prezzi.split("||");
            secondi.allergeni = snapshot.val()?.secondi?.allergeni?.split("||");

          }
          else {
            secondi.titoli = "|";
          }
          //Secondi


          //Contorni
          let contorni = {};
          if (snapshot.val().contorni) {
            contorni.titoli = snapshot.val()?.contorni.titoli.split("||");
            contorni.descrizioni = snapshot.val()?.contorni.descrizioni.split("||");
            contorni.prezzi = snapshot.val()?.contorni.prezzi.split("||");
            contorni.allergeni = snapshot.val()?.contorni?.allergeni?.split("||");

          }
          else {
            contorni.titoli = "|";

          }
          //Contorni



          //Bevande
          let bevande = {};
          if (snapshot.val().bevande) {
            bevande.titoli = snapshot.val()?.bevande.titoli.split("||");
            bevande.descrizioni = snapshot.val()?.bevande.descrizioni.split("||");
            bevande.prezzi = snapshot.val()?.bevande.prezzi.split("||");
          }
          else {
            bevande.titoli = "|";
          }

          //Bevande


          //Dolci
          let dolci = {};
          if (snapshot.val().dolci) {
            dolci.titoli = snapshot.val()?.dolci.titoli.split("||");
            dolci.descrizioni = snapshot.val()?.dolci.descrizioni.split("||");
            dolci.prezzi = snapshot.val()?.dolci.prezzi.split("||");
            dolci.allergeni = snapshot.val()?.dolci?.allergeni.split("||");

          }
          else {
            dolci.titoli = "|";
          }
          //Dolci

          let rossi = {};
          if (snapshot.val().rossi) {
            rossi.titoli = snapshot.val()?.rossi.titoli.split("||");
            rossi.descrizioni = snapshot.val()?.rossi.descrizioni.split("||");
            rossi.prezzi = snapshot.val()?.rossi.prezzi.split("||");
          }
          else {
            rossi.titoli = "|";
          }

          let bianchi = {};
          if (snapshot.val().bianchi) {
            bianchi.titoli = snapshot.val()?.bianchi.titoli.split("||");
            bianchi.descrizioni = snapshot.val()?.bianchi.descrizioni.split("||");
            bianchi.prezzi = snapshot.val()?.bianchi.prezzi.split("||");
          }
          else {
            bianchi.titoli = "|";
          }

          let rosati = {};
          if (snapshot.val().rosati) {
            rosati.titoli = snapshot.val()?.rosati.titoli.split("||");
            rosati.descrizioni = snapshot.val()?.rosati.descrizioni.split("||");
            rosati.prezzi = snapshot.val()?.rosati.prezzi.split("||");
          }
          else {
            rosati.titoli = "|";
          }

          let bollicine = {};
          if (snapshot.val().bollicine) {
            bollicine.titoli = snapshot.val()?.bollicine.titoli.split("||");
            bollicine.descrizioni = snapshot.val()?.bollicine.descrizioni.split("||");
            bollicine.prezzi = snapshot.val()?.bollicine.prezzi.split("||");
          }
          else {
            bollicine.titoli = "|";
          }

          let distillati = {};
          if (snapshot.val().distillati) {
            distillati.titoli = snapshot.val()?.distillati.titoli.split("||");
            distillati.descrizioni = snapshot.val()?.distillati.descrizioni.split("||");
            distillati.prezzi = snapshot.val()?.distillati.prezzi.split("||");
          }
          else {
            distillati.titoli = "|";
          }




          let anti = [];
          let prim = [];
          let sec = [];
          let cont = [];
          let bev = [];
          let dolc = [];
          let ross = [];
          let bianc = [];
          let rosa = [];
          let boll = [];
          let dist =[];




          for (let i = 0; i < antipasti.titoli.length - 1; i++) {


            anti[i] = {
              id: i,
              titolo: antipasti.titoli[i],
              descrizione: antipasti.descrizioni[i],
              prezzo: antipasti.prezzi[i],
              allergeno: antipasti.allergeni[i],

            }
          }
          for (let i = 0; i < primi.titoli.length - 1; i++) {
            prim[i] = {
              id: i,
              titolo: primi.titoli[i],
              descrizione: primi.descrizioni[i],
              prezzo: primi.prezzi[i],
              allergeno: primi.allergeni[i],


            }
          }
          for (let i = 0; i < secondi.titoli.length - 1; i++) {
            sec[i] = {
              id: i,
              titolo: secondi.titoli[i],
              descrizione: secondi.descrizioni[i],
              prezzo: secondi.prezzi[i],
              allergeno: secondi.allergeni[i],


            }
          }
          for (let i = 0; i < contorni.titoli.length - 1; i++) {
            cont[i] = {
              id: i,
              titolo: contorni.titoli[i],
              descrizione: contorni.descrizioni[i],
              prezzo: contorni.prezzi[i],
              allergeno: contorni.allergeni[i],


            }
          }
          for (let i = 0; i < bevande.titoli.length - 1; i++) {
            bev[i] = {
              id: i,
              titolo: bevande.titoli[i],
              descrizione: bevande.descrizioni[i],
              prezzo: bevande.prezzi[i]

            }
          }
          for (let i = 0; i < dolci.titoli.length - 1; i++) {
            dolc[i] = {
              id: i,
              titolo: dolci.titoli[i],
              descrizione: dolci.descrizioni[i],
              prezzo: dolci.prezzi[i],
              allergeno: dolci.allergeni[i],


            }
            for (let i = 0; i < rossi.titoli.length - 1; i++) {
              ross[i] = {
                id: i,
                titolo: rossi.titoli[i],
                descrizione: rossi.descrizioni[i],
                prezzo: rossi.prezzi[i]

              }
            }
            for (let i = 0; i < bianchi.titoli.length - 1; i++) {
              bianc[i] = {
                id: i,
                titolo: bianchi.titoli[i],
                descrizione: bianchi.descrizioni[i],
                prezzo: bianchi.prezzi[i]

              }
            }
            for (let i = 0; i < rosati.titoli.length - 1; i++) {
              rosa[i] = {
                id: i,
                titolo: rosati.titoli[i],
                descrizione: rosati.descrizioni[i],
                prezzo: rosati.prezzi[i]

              }
            }
            for (let i = 0; i < bollicine.titoli.length - 1; i++) {
              boll[i] = {
                id: i,
                titolo: bollicine.titoli[i],
                descrizione: bollicine.descrizioni[i],
                prezzo: bollicine.prezzi[i]

              }
            }

          }
          for (let i = 0; i < distillati.titoli.length - 1; i++) {
            dist[i] = {
              id: i,
              titolo: distillati.titoli[i],
              descrizione: distillati.descrizioni[i],
              prezzo: distillati.prezzi[i]

            }
          }


          setAntipasti(anti);
          setPrimi(prim);
          setSecondi(sec);
          setContorni(cont);
          setBevande(bev);
          setDolci(dolc);
          setRossi(ross);
          setBianchi(bianc);
          setRosati(rosa);
          setBollicine(boll);
          setDistillati(dist);


        });
    }
    else {
      firebase.database().ref("/inglese")
        .once('value')
        .then(snapshot => {

          //Antipasti
          let antipasti = {};
          if (snapshot.val().antipasti) {
            antipasti.titoli = snapshot.val()?.antipasti.titoli.split("||");
            antipasti.descrizioni = snapshot.val()?.antipasti.descrizioni.split("||");
            antipasti.prezzi = snapshot.val()?.antipasti.prezzi.split("||");
            antipasti.allergeni = snapshot.val()?.antipasti?.allergeni?.split("||");

          }
          else {
            antipasti.titoli = "|";
          }
          //Antipasti


          //Primi
          let primi = {};
          if (snapshot.val().primi) {

            primi.titoli = snapshot.val()?.primi.titoli.split("||");
            primi.descrizioni = snapshot.val()?.primi.descrizioni.split("||");
            primi.prezzi = snapshot.val()?.primi.prezzi.split("||");
            primi.allergeni = snapshot.val()?.antipasti?.allergeni?.split("||");

          }
          else {
            primi.titoli = "|";
          }
          //Primi


          //Secondi
          let secondi = {};
          if (snapshot.val().secondi) {

            secondi.titoli = snapshot.val()?.secondi.titoli.split("||");
            secondi.descrizioni = snapshot.val()?.secondi.descrizioni.split("||");
            secondi.prezzi = snapshot.val()?.secondi.prezzi.split("||");
            secondi.allergeni = snapshot.val()?.antipasti?.allergeni?.split("||");

          }
          else {
            secondi.titoli = "|";
          }
          //Secondi


          //Contorni
          let contorni = {};
          if (snapshot.val().contorni) {
            contorni.titoli = snapshot.val()?.contorni.titoli.split("||");
            contorni.descrizioni = snapshot.val()?.contorni.descrizioni.split("||");
            contorni.prezzi = snapshot.val()?.contorni.prezzi.split("||");
            contorni.allergeni = snapshot.val()?.antipasti?.allergeni?.split("||");

          }
          else {
            contorni.titoli = "|";

          }
          //Contorni



          //Bevande
          let bevande = {};
          if (snapshot.val().bevande) {
            bevande.titoli = snapshot.val()?.bevande.titoli.split("||");
            bevande.descrizioni = snapshot.val()?.bevande.descrizioni.split("||");
            bevande.prezzi = snapshot.val()?.bevande.prezzi.split("||");

          }
          else {
            bevande.titoli = "|";
          }

          //Bevande


          //Dolci
          let dolci = {};
          if (snapshot.val().dolci) {
            dolci.titoli = snapshot.val()?.dolci.titoli.split("||");
            dolci.descrizioni = snapshot.val()?.dolci.descrizioni.split("||");
            dolci.prezzi = snapshot.val()?.dolci.prezzi.split("||");
            dolci.allergeni = snapshot.val()?.antipasti?.allergeni?.split("||");

          }
          else {
            dolci.titoli = "|";
          }
          //Dolci

          let rossi = {};
          if (snapshot.val().rossi) {
            rossi.titoli = snapshot.val()?.rossi.titoli.split("||");
            rossi.descrizioni = snapshot.val()?.rossi.descrizioni.split("||");
            rossi.prezzi = snapshot.val()?.rossi.prezzi.split("||");
          }
          else {
            rossi.titoli = "|";
          }

          let bianchi = {};
          if (snapshot.val().bianchi) {
            bianchi.titoli = snapshot.val()?.bianchi.titoli.split("||");
            bianchi.descrizioni = snapshot.val()?.bianchi.descrizioni.split("||");
            bianchi.prezzi = snapshot.val()?.bianchi.prezzi.split("||");
          }
          else {
            bianchi.titoli = "|";
          }

          let rosati = {};
          if (snapshot.val().rosati) {
            rosati.titoli = snapshot.val()?.rosati.titoli.split("||");
            rosati.descrizioni = snapshot.val()?.rosati.descrizioni.split("||");
            rosati.prezzi = snapshot.val()?.rosati.prezzi.split("||");
          }
          else {
            rosati.titoli = "|";
          }

          let bollicine = {};
          if (snapshot.val().bollicine) {
            bollicine.titoli = snapshot.val()?.bollicine.titoli.split("||");
            bollicine.descrizioni = snapshot.val()?.bollicine.descrizioni.split("||");
            bollicine.prezzi = snapshot.val()?.bollicine.prezzi.split("||");
          }
          else {
            bollicine.titoli = "|";
          }

          let distillati = {};
          if (snapshot.val().distillati) {
            distillati.titoli = snapshot.val()?.distillati.titoli.split("||");
            distillati.descrizioni = snapshot.val()?.distillati.descrizioni.split("||");
            distillati.prezzi = snapshot.val()?.distillati.prezzi.split("||");
          }
          else {
            distillati.titoli = "|";
          }


          let anti = [];
          let prim = [];
          let sec = [];
          let cont = [];
          let bev = [];
          let dolc = [];
          let ross = [];
          let bianc = [];
          let rosa = [];
          let boll = [];
          let dist = [];



          for (let i = 0; i < antipasti.titoli.length - 1; i++) {


            anti[i] = {
              id: i,
              titolo: antipasti.titoli[i],
              descrizione: antipasti.descrizioni[i],
              prezzo: antipasti.prezzi[i],
              allergeno: antipasti.allergeni[i],


            }
          }
          for (let i = 0; i < primi.titoli.length - 1; i++) {
            prim[i] = {
              id: i,
              titolo: primi.titoli[i],
              descrizione: primi.descrizioni[i],
              prezzo: primi.prezzi[i],
              allergeno: primi.allergeni[i],


            }
          }
          for (let i = 0; i < secondi.titoli.length - 1; i++) {
            sec[i] = {
              id: i,
              titolo: secondi.titoli[i],
              descrizione: secondi.descrizioni[i],
              prezzo: secondi.prezzi[i],
              allergeno: secondi.allergeni[i],


            }
          }
          for (let i = 0; i < contorni.titoli.length - 1; i++) {
            cont[i] = {
              id: i,
              titolo: contorni.titoli[i],
              descrizione: contorni.descrizioni[i],
              prezzo: contorni.prezzi[i],
              allergeno: contorni.allergeni[i],


            }
          }
          for (let i = 0; i < bevande.titoli.length - 1; i++) {
            bev[i] = {
              id: i,
              titolo: bevande.titoli[i],
              descrizione: bevande.descrizioni[i],
              prezzo: bevande.prezzi[i]

            }
          }
          for (let i = 0; i < dolci.titoli?.length - 1; i++) {
            dolc[i] = {
              id: i,
              titolo: dolci.titoli[i],
              descrizione: dolci.descrizioni[i],
              prezzo: dolci.prezzi[i],
              allergeno: dolci.allergeni[i],


            }

          }
          for (let i = 0; i < rossi.titoli?.length - 1; i++) {
            ross[i] = {
              id: i,
              titolo: rossi.titoli[i],
              descrizione: rossi.descrizioni[i],
              prezzo: rossi.prezzi[i]

            }
          }
          for (let i = 0; i < bianchi.titoli?.length - 1; i++) {
            bianc[i] = {
              id: i,
              titolo: bianchi.titoli[i],
              descrizione: bianchi.descrizioni[i],
              prezzo: bianchi.prezzi[i]

            }
          }
          for (let i = 0; i < rosati.titoli.length - 1; i++) {
            rosa[i] = {
              id: i,
              titolo: rosati.titoli[i],
              descrizione: rosati.descrizioni[i],
              prezzo: rosati.prezzi[i]

            }
          }
          for (let i = 0; i < bollicine.titoli.length - 1; i++) {
            boll[i] = {
              id: i,
              titolo: bollicine.titoli[i],
              descrizione: bollicine.descrizioni[i],
              prezzo: bollicine.prezzi[i]

            }
          }
          for (let i = 0; i < distillati.titoli.length - 1; i++) {
            dist[i] = {
              id: i,
              titolo: distillati.titoli[i],
              descrizione: distillati.descrizioni[i],
              prezzo: distillati.prezzi[i]

            }
          }


          setAntipasti(anti);
          setPrimi(prim);
          setSecondi(sec);
          setContorni(cont);
          setBevande(bev);
          setDolci(dolc);
          setRossi(ross);
          setBianchi(bianc);
          setRosati(rosa);
          setBollicine(boll);
          setDistillati(dist);

        });
    }

  }

  useEffect(() => {
    get(lingua)

  }, [])
  useEffect(() => {
    get(lingua)

  }, [lingua])

  const handleChange = (event, newValue) => {
    setValue(newValue);
    window.scrollTo(0, 0);
  };
  return (
    <Container maxWidth="xl" sx={{ margin: "0", padding: "0" }}>

      <Box sx={{ width: '100%', position: 'fixed', bgcolor: "background.paper" }}>
        <Box display="flex" justifyContent="center" alignItems="center" sx={{ width: '100%', height: "10vh", bgcolor: "background.paper" }}>
          <Box
            component="img"
            sx={{
              height: "0vh",
              width: "30vw",


            }}


          />
          <Box
            component="img"
            sx={{
              height: "9vh",
              width: "30vw",
              maxHeight: 137,
              maxWidth: 200

            }}

            alt="Sasà"
            src="sasalogo.png"
          />
          <Stack alignItems="center"
            sx={{

              width: "30vw",


            }}>
            <IconButton
              ref={anchorRef}
              onClick={handleOpen}
              sx={{
                padding: 0,
                width: 60,
                height: 60,
                ...(open && {
                  bgcolor: (theme) => alpha(theme.palette.primary.main, theme.palette.action.focusOpacity)
                })
              }}
            >
              {
                lingua == "it" ?
                  <img src={LANGS[0].icon} alt={LANGS[0].label} />
                  :
                  <img src={LANGS[1].icon} alt={LANGS[1].label} />
              }

            </IconButton>

            <MenuPopover open={open} onClose={handleClose} anchorEl={anchorRef.current}>
              <Box sx={{ py: 1 }}>
                {LANGS.map((option) => (
                  <MenuItem
                    key={option.value}
                    selected={option.value === lingua}
                    onClick={() => handleClose(option.value)}
                    sx={{ py: 1, px: 2.5 }}
                  >
                    <ListItemIcon>
                      <Box component="img" alt={option.label} src={option.icon} />
                    </ListItemIcon>
                    <ListItemText primaryTypographyProps={{ variant: 'body2' }}>
                      {option.label}
                    </ListItemText>
                  </MenuItem>
                ))}
              </Box>
            </MenuPopover>
          </Stack>
        </Box>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>

          <Tabs variant="scrollable" value={value} onChange={handleChange} aria-label="basic tabs example">
            <Tab label={lingua == "it" ? "Tutto" : "All"}  {...a11yProps(0)} />
            <Tab label={lingua == "it" ? "Antipasti" : "Starter"} {...a11yProps(1)} />
            <Tab label={lingua == "it" ? "Primi" : "first dishes"} {...a11yProps(2)} />
            <Tab label={lingua == "it" ? "Secondi" : "Second courses"} {...a11yProps(3)} />
            <Tab label={lingua == "it" ? "Contorni" : "Side dishes"} {...a11yProps(4)} />
            <Tab label={lingua == "it" ? "Bevande" : "Drinks"} {...a11yProps(5)} />
            <Tab label={lingua == "it" ? "Dolci" : "Dessert"} {...a11yProps(6)} />
            <Tab label={lingua == "it" ? "Vini Rossi" : "Vini Rossi"} {...a11yProps(7)} />
            <Tab label={lingua == "it" ? "Vini Bianchi" : "Vini Bianchi"} {...a11yProps(8)} />
            <Tab label={lingua == "it" ? "Vini Rosati" : "Vini Rosati"} {...a11yProps(9)} />
            <Tab label={lingua == "it" ? "Vini Bollicine" : "Vini Bollicine"} {...a11yProps(10)} />
            <Tab label={lingua == "it" ? "Distillati" : "Distillati"} {...a11yProps(11)} />




          </Tabs>
        </Box>
      </Box>
      <TabPanel value={value} index={0} sx={{ margin: "0", padding: "0" }}>

        <Typography variant="h5" sx={{ fontWeight: "500", marginTop: "15vh", }} gutterBottom component="div">
          {lingua == "it" ? "Antipasti" : "Starter"}
        </Typography>
        <Divider />



        {
          antipasti.map((video) => {

            const { id, titolo, descrizione, prezzo, allergeno } = video;
            return (
              <>
                <Box>
                  <Typography gutterBottom variant="h6" component="div">
                    {titolo}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {descrizione}
                  </Typography>

                  <Typography inline variant="body1" color="text.secondary" align='right'>
                    {prezzo}€
                  </Typography>
                  {
                    allergeno != " " && allergeno != "," && allergeno != "" ?
                      <Stack direction="row">
                        <Typography inline variant="body1" color="text.secondary" align='left'>
                          Allergeni
                        </Typography>
                        {allergeno.includes("Cereali") ? <img src={'allergeni/grano.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Crostacei") ? <img src={'allergeni/crostacei.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Uova") ? <img src={'allergeni/uova.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Pesce") ? <img src={'allergeni/pesce.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Arachidi") ? <img src={'allergeni/arachidi.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Soia") ? <img src={'allergeni/soia.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Latte") ? <img src={'allergeni/latte.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Frutta a Guscio") ? <img src={'allergeni/ghianda.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Sedano") ? <img src={'allergeni/sedano.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Senape") ? <img src={'allergeni/senape.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Sesamo") ? <img src={'allergeni/sesamo.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Solforosa") ? <img src={'allergeni/so2.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Lupini") ? <img src={'allergeni/lupini.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Molluschi") ? <img src={'allergeni/mollusco.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                      </Stack>
                      :
                      null
                  }



                </Box>
                <Divider />
              </>
            )
          })

        }

        <Typography variant="h5" sx={{ fontWeight: "500", marginTop: "4vh", }} gutterBottom component="div">
          {lingua == "it" ? "Primi" : "first dishes"}
        </Typography>
        <Divider />



        {
          primi.map((video) => {

            const { id, titolo, descrizione, prezzo, allergeno } = video;
            return (
              <>
                <Box>
                  <Typography gutterBottom variant="h6" component="div">
                    {titolo}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {descrizione}
                  </Typography>

                  <Typography inline variant="body1" color="text.secondary" align='right'>
                    {prezzo}€
                  </Typography>
                  {
                    allergeno != " " && allergeno != "," && allergeno != "" ?
                      <Stack direction="row">
                        <Typography inline variant="body1" color="text.secondary" align='left'>
                          Allergeni
                        </Typography>
                        {allergeno.includes("Cereali") ? <img src={'allergeni/grano.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Crostacei") ? <img src={'allergeni/crostacei.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Uova") ? <img src={'allergeni/uova.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Pesce") ? <img src={'allergeni/pesce.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Arachidi") ? <img src={'allergeni/arachidi.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Soia") ? <img src={'allergeni/soia.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Latte") ? <img src={'allergeni/latte.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Frutta a Guscio") ? <img src={'allergeni/ghianda.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Sedano") ? <img src={'allergeni/sedano.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Senape") ? <img src={'allergeni/senape.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Sesamo") ? <img src={'allergeni/sesamo.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Solforosa") ? <img src={'allergeni/so2.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Lupini") ? <img src={'allergeni/lupini.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Molluschi") ? <img src={'allergeni/mollusco.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                      </Stack>
                      :
                      null
                  }



                </Box>
                <Divider />
              </>
            )
          })

        }

        <Typography variant="h5" sx={{ fontWeight: "500", marginTop: "4vh", }} gutterBottom component="div">
          {lingua == "it" ? "Secondi" : "Second courses"}

        </Typography>
        <Divider />



        {
          secondi.map((video) => {

            const { id, titolo, descrizione, prezzo, allergeno } = video;
            return (
              <>
                <Box>
                  <Typography gutterBottom variant="h6" component="div">
                    {titolo}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {descrizione}
                  </Typography>

                  <Typography inline variant="body1" color="text.secondary" align='right'>
                    {prezzo}€
                  </Typography>
                  {
                    allergeno != " " && allergeno != "," && allergeno != "" ?
                      <Stack direction="row">
                        <Typography inline variant="body1" color="text.secondary" align='left'>
                          Allergeni
                        </Typography>
                        {allergeno.includes("Cereali") ? <img src={'allergeni/grano.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Crostacei") ? <img src={'allergeni/crostacei.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Uova") ? <img src={'allergeni/uova.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Pesce") ? <img src={'allergeni/pesce.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Arachidi") ? <img src={'allergeni/arachidi.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Soia") ? <img src={'allergeni/soia.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Latte") ? <img src={'allergeni/latte.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Frutta a Guscio") ? <img src={'allergeni/ghianda.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Sedano") ? <img src={'allergeni/sedano.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Senape") ? <img src={'allergeni/senape.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Sesamo") ? <img src={'allergeni/sesamo.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Solforosa") ? <img src={'allergeni/so2.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Lupini") ? <img src={'allergeni/lupini.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Molluschi") ? <img src={'allergeni/mollusco.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                      </Stack>
                      :
                      null
                  }


                </Box>
                <Divider />
              </>
            )
          })

        }

        <Typography variant="h5" sx={{ fontWeight: "500", marginTop: "4vh", }} gutterBottom component="div">
          {lingua == "it" ? "Contorni" : "Side dishes"}
        </Typography>
        <Divider />



        {
          contorni.map((video) => {

            const { id, titolo, descrizione, prezzo, allergeno } = video;
            return (
              <>
                <Box>
                  <Typography gutterBottom variant="h6" component="div">
                    {titolo}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {descrizione}
                  </Typography>

                  <Typography inline variant="body1" color="text.secondary" align='right'>
                    {prezzo}€
                  </Typography>
                  {
                    allergeno != " " && allergeno != "," && allergeno != "" ?
                      <Stack direction="row">
                        <Typography inline variant="body1" color="text.secondary" align='left'>
                          Allergeni
                        </Typography>
                        {allergeno.includes("Cereali") ? <img src={'allergeni/grano.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Crostacei") ? <img src={'allergeni/crostacei.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Uova") ? <img src={'allergeni/uova.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Pesce") ? <img src={'allergeni/pesce.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Arachidi") ? <img src={'allergeni/arachidi.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Soia") ? <img src={'allergeni/soia.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Latte") ? <img src={'allergeni/latte.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Frutta a Guscio") ? <img src={'allergeni/ghianda.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Sedano") ? <img src={'allergeni/sedano.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Senape") ? <img src={'allergeni/senape.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Sesamo") ? <img src={'allergeni/sesamo.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Solforosa") ? <img src={'allergeni/so2.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Lupini") ? <img src={'allergeni/lupini.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Molluschi") ? <img src={'allergeni/mollusco.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                      </Stack>
                      :
                      null
                  }


                </Box>
                <Divider />
              </>
            )
          })

        }

        <Typography variant="h5" sx={{ fontWeight: "500", marginTop: "4vh", }} gutterBottom component="div">
          {lingua == "it" ? "Bevande" : "Drinks"}

        </Typography>
        <Divider />



        {
          bevande.map((video) => {

            const { id, titolo, descrizione, prezzo } = video;
            return (
              <>
                <Box>
                  <Typography gutterBottom variant="h6" component="div">
                    {titolo}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {descrizione}
                  </Typography>

                  <Typography inline variant="body1" color="text.secondary" align='right'>
                    {prezzo}€
                  </Typography>



                </Box>
                <Divider />
              </>
            )
          })

        }

        <Typography variant="h5" sx={{ fontWeight: "500", marginTop: "4vh", }} gutterBottom component="div">
          {lingua == "it" ? "Dolci" : "Dessert"}

        </Typography>
        <Divider />



        {
          dolci.map((video) => {

            const { id, titolo, descrizione, prezzo, allergeno } = video;
            return (
              <>
                <Box>
                  <Typography gutterBottom variant="h6" component="div">
                    {titolo}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {descrizione}
                  </Typography>

                  <Typography inline variant="body1" color="text.secondary" align='right'>
                    {prezzo}€
                  </Typography>
                  {
                    allergeno != " " && allergeno != "," && allergeno != "" ?
                      <Stack direction="row">
                        <Typography inline variant="body1" color="text.secondary" align='left'>
                          Allergeni
                        </Typography>
                        {allergeno.includes("Cereali") ? <img src={'allergeni/grano.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Crostacei") ? <img src={'allergeni/crostacei.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Uova") ? <img src={'allergeni/uova.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Pesce") ? <img src={'allergeni/pesce.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Arachidi") ? <img src={'allergeni/arachidi.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Soia") ? <img src={'allergeni/soia.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Latte") ? <img src={'allergeni/latte.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Frutta a Guscio") ? <img src={'allergeni/ghianda.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Sedano") ? <img src={'allergeni/sedano.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Senape") ? <img src={'allergeni/senape.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Sesamo") ? <img src={'allergeni/sesamo.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Solforosa") ? <img src={'allergeni/so2.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Lupini") ? <img src={'allergeni/lupini.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Molluschi") ? <img src={'allergeni/mollusco.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                      </Stack>
                      :
                      null
                  }


                </Box>
                <Divider />
              </>
            )
          })

        }

      


      </TabPanel>
      <TabPanel value={value} index={1}>
        <Typography variant="h5" sx={{ fontWeight: "500", marginTop: "15vh", }} gutterBottom component="div">
          {lingua == "it" ? "Antipasti" : "Starter"}

        </Typography>
        <Divider />



        {
          antipasti.map((piatti) => {

            const { id, titolo, descrizione, prezzo, allergeno } = piatti;
            return (
              <>
                <Box>
                  <Typography gutterBottom variant="h6" component="div">
                    {titolo}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {descrizione}
                  </Typography>

                  <Typography inline variant="body1" color="text.secondary" align='right'>
                    {prezzo}€
                  </Typography>
                  {
                    allergeno != " " && allergeno != "," && allergeno != "" ?
                      <Stack direction="row">
                        <Typography inline variant="body1" color="text.secondary" align='left'>
                          Allergeni
                        </Typography>
                        {allergeno.includes("Cereali") ? <img src={'allergeni/grano.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Crostacei") ? <img src={'allergeni/crostacei.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Uova") ? <img src={'allergeni/uova.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Pesce") ? <img src={'allergeni/pesce.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Arachidi") ? <img src={'allergeni/arachidi.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Soia") ? <img src={'allergeni/soia.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Latte") ? <img src={'allergeni/latte.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Frutta a Guscio") ? <img src={'allergeni/ghianda.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Sedano") ? <img src={'allergeni/sedano.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Senape") ? <img src={'allergeni/senape.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Sesamo") ? <img src={'allergeni/sesamo.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Solforosa") ? <img src={'allergeni/so2.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Lupini") ? <img src={'allergeni/lupini.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Molluschi") ? <img src={'allergeni/mollusco.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                      </Stack>
                      :
                      null
                  }



                </Box>
                <Divider />
              </>
            )
          })

        }
        
      </TabPanel>
      <TabPanel value={value} index={2}>
        <Typography variant="h5" sx={{ fontWeight: "500", marginTop: "15vh", }} gutterBottom component="div">
          {lingua == "it" ? "Primi" : "first dishes"}
        </Typography>
        <Divider />



        {
          primi.map((piatti) => {

            const { id, titolo, descrizione, prezzo, allergeno } = piatti;
            return (
              <>
                <Box>
                  <Typography gutterBottom variant="h6" component="div">
                    {titolo}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {descrizione}
                  </Typography>

                  <Typography inline variant="body1" color="text.secondary" align='right'>
                    {prezzo}€
                  </Typography>
                  {
                    allergeno != " " && allergeno != "," && allergeno != "" ?
                      <Stack direction="row">
                        <Typography inline variant="body1" color="text.secondary" align='left'>
                          Allergeni
                        </Typography>
                        {allergeno.includes("Cereali") ? <img src={'allergeni/grano.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Crostacei") ? <img src={'allergeni/crostacei.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Uova") ? <img src={'allergeni/uova.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Pesce") ? <img src={'allergeni/pesce.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Arachidi") ? <img src={'allergeni/arachidi.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Soia") ? <img src={'allergeni/soia.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Latte") ? <img src={'allergeni/latte.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Frutta a Guscio") ? <img src={'allergeni/ghianda.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Sedano") ? <img src={'allergeni/sedano.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Senape") ? <img src={'allergeni/senape.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Sesamo") ? <img src={'allergeni/sesamo.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Solforosa") ? <img src={'allergeni/so2.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Lupini") ? <img src={'allergeni/lupini.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Molluschi") ? <img src={'allergeni/mollusco.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                      </Stack>
                      :
                      null
                  }


                </Box>
                <Divider />
              </>
            )
          })

        }
      </TabPanel>

      <TabPanel value={value} index={3}>
        <Typography variant="h5" sx={{ fontWeight: "500", marginTop: "15vh", }} gutterBottom component="div">
          {lingua == "it" ? "Secondi" : "Second courses"}

        </Typography>
        <Divider />



        {
          secondi.map((piatti) => {

            const { id, titolo, descrizione, prezzo, allergeno } = piatti;
            return (
              <>
                <Box>
                  <Typography gutterBottom variant="h6" component="div">
                    {titolo}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {descrizione}
                  </Typography>

                  <Typography inline variant="body1" color="text.secondary" align='right'>
                    {prezzo}€
                  </Typography>

                  {
                    allergeno != " " && allergeno != "," && allergeno != "" ?
                      <Stack direction="row">
                        <Typography inline variant="body1" color="text.secondary" align='left'>
                          Allergeni
                        </Typography>
                        {allergeno.includes("Cereali") ? <img src={'allergeni/grano.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Crostacei") ? <img src={'allergeni/crostacei.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Uova") ? <img src={'allergeni/uova.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Pesce") ? <img src={'allergeni/pesce.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Arachidi") ? <img src={'allergeni/arachidi.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Soia") ? <img src={'allergeni/soia.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Latte") ? <img src={'allergeni/latte.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Frutta a Guscio") ? <img src={'allergeni/ghianda.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Sedano") ? <img src={'allergeni/sedano.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Senape") ? <img src={'allergeni/senape.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Sesamo") ? <img src={'allergeni/sesamo.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Solforosa") ? <img src={'allergeni/so2.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Lupini") ? <img src={'allergeni/lupini.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Molluschi") ? <img src={'allergeni/mollusco.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                      </Stack>
                      :
                      null
                  }

                </Box>
                <Divider />
              </>
            )
          })

        }
      </TabPanel>

      <TabPanel value={value} index={4}>
        <Typography variant="h5" sx={{ fontWeight: "500", marginTop: "15vh", }} gutterBottom component="div">
          {lingua == "it" ? "Contorni" : "Side dishes"}

        </Typography>
        <Divider />



        {
          contorni.map((piatti) => {

            const { id, titolo, descrizione, prezzo, allergeno } = piatti;
            return (
              <>
                <Box>
                  <Typography gutterBottom variant="h6" component="div">
                    {titolo}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {descrizione}
                  </Typography>

                  <Typography inline variant="body1" color="text.secondary" align='right'>
                    {prezzo}€
                  </Typography>
                  {
                    allergeno != " " && allergeno != "," && allergeno != "" ?
                      <Stack direction="row">
                        <Typography inline variant="body1" color="text.secondary" align='left'>
                          Allergeni
                        </Typography>
                        {allergeno.includes("Cereali") ? <img src={'allergeni/grano.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Crostacei") ? <img src={'allergeni/crostacei.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Uova") ? <img src={'allergeni/uova.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Pesce") ? <img src={'allergeni/pesce.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Arachidi") ? <img src={'allergeni/arachidi.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Soia") ? <img src={'allergeni/soia.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Latte") ? <img src={'allergeni/latte.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Frutta a Guscio") ? <img src={'allergeni/ghianda.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Sedano") ? <img src={'allergeni/sedano.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Senape") ? <img src={'allergeni/senape.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Sesamo") ? <img src={'allergeni/sesamo.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Solforosa") ? <img src={'allergeni/so2.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Lupini") ? <img src={'allergeni/lupini.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Molluschi") ? <img src={'allergeni/mollusco.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                      </Stack>
                      :
                      null
                  }


                </Box>
                <Divider />
              </>
            )
          })

        }
      </TabPanel>

      <TabPanel value={value} index={5}>
        <Typography variant="h5" sx={{ fontWeight: "500", marginTop: "15vh", }} gutterBottom component="div">
          {lingua == "it" ? "Bevande" : "Drinks"}

        </Typography>
        <Divider />



        {
          bevande.map((piatti) => {

            const { id, titolo, descrizione, prezzo, } = piatti;
            return (
              <>
                <Box>
                  <Typography gutterBottom variant="h6" component="div">
                    {titolo}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {descrizione}
                  </Typography>

                  <Typography inline variant="body1" color="text.secondary" align='right'>
                    {prezzo}€
                  </Typography>


                </Box>
                <Divider />
              </>
            )
          })

        }
      </TabPanel>

      <TabPanel value={value} index={6}>
        <Typography variant="h5" sx={{ fontWeight: "500", marginTop: "15vh", }} gutterBottom component="div">
          {lingua == "it" ? "Dolci" : "Dessert"}

        </Typography>
        <Divider />



        {
          dolci.map((piatti) => {

            const { id, titolo, descrizione, prezzo, allergeno } = piatti;
            return (
              <>
                <Box>
                  <Typography gutterBottom variant="h6" component="div">
                    {titolo}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {descrizione}
                  </Typography>

                  <Typography inline variant="body1" color="text.secondary" align='right'>
                    {prezzo}€
                  </Typography>

                  {
                    allergeno != " " && allergeno != "," && allergeno != "" ?
                      <Stack direction="row">
                        <Typography inline variant="body1" color="text.secondary" align='left'>
                          Allergeni
                        </Typography>
                        {allergeno.includes("Cereali") ? <img src={'allergeni/grano.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Crostacei") ? <img src={'allergeni/crostacei.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Uova") ? <img src={'allergeni/uova.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Pesce") ? <img src={'allergeni/pesce.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Arachidi") ? <img src={'allergeni/arachidi.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Soia") ? <img src={'allergeni/soia.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Latte") ? <img src={'allergeni/latte.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Frutta a Guscio") ? <img src={'allergeni/ghianda.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Sedano") ? <img src={'allergeni/sedano.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Senape") ? <img src={'allergeni/senape.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Sesamo") ? <img src={'allergeni/sesamo.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Solforosa") ? <img src={'allergeni/so2.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Lupini") ? <img src={'allergeni/lupini.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                        {allergeno.includes("Molluschi") ? <img src={'allergeni/mollusco.png'} style={{ height: 20, width: 20, marginLeft: 5 }} /> : null}
                      </Stack>
                      :
                      null
                  }

                </Box>
                <Divider />
              </>
            )
          })

        }
      </TabPanel>

      <TabPanel value={value} index={7}>
        <Typography variant="h5" sx={{ fontWeight: "500", marginTop: "15vh", }} gutterBottom component="div">
          {lingua == "it" ? "Vini Rossi" : "Vini Rossi"}

        </Typography>
        <Divider />



        {
          rossi.map((piatti) => {

            const { id, titolo, descrizione, prezzo, } = piatti;
            return (
              <>
                <Box>
                  <Typography gutterBottom variant="h6" component="div">
                    {titolo}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {descrizione}
                  </Typography>

                  <Typography inline variant="body1" color="text.secondary" align='right'>
                    {prezzo}€
                  </Typography>


                </Box>
                <Divider />
              </>
            )
          })

        }
      </TabPanel>

      <TabPanel value={value} index={8}>
        <Typography variant="h5" sx={{ fontWeight: "500", marginTop: "15vh", }} gutterBottom component="div">
          {lingua == "it" ? "Vini Bianchi" : "Vini Bianchi"}

        </Typography>
        <Divider />



        {
          bianchi.map((piatti) => {

            const { id, titolo, descrizione, prezzo, } = piatti;
            return (
              <>
                <Box>
                  <Typography gutterBottom variant="h6" component="div">
                    {titolo}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {descrizione}
                  </Typography>

                  <Typography inline variant="body1" color="text.secondary" align='right'>
                    {prezzo}€
                  </Typography>


                </Box>
                <Divider />
              </>
            )
          })

        }
      </TabPanel>

      <TabPanel value={value} index={9}>
        <Typography variant="h5" sx={{ fontWeight: "500", marginTop: "15vh", }} gutterBottom component="div">
          {lingua == "it" ? "Vini Rosati" : "Vini Rosati"}

        </Typography>
        <Divider />



        {
          rosati.map((piatti) => {

            const { id, titolo, descrizione, prezzo, } = piatti;
            return (
              <>
                <Box>
                  <Typography gutterBottom variant="h6" component="div">
                    {titolo}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {descrizione}
                  </Typography>

                  <Typography inline variant="body1" color="text.secondary" align='right'>
                    {prezzo}€
                  </Typography>


                </Box>
                <Divider />
              </>
            )
          })

        }
      </TabPanel>


      <TabPanel value={value} index={10}>
        <Typography variant="h5" sx={{ fontWeight: "500", marginTop: "15vh", }} gutterBottom component="div">
          {lingua == "it" ? "Vini Bollicine" : "Vini Bollicine"}

        </Typography>
        <Divider />



        {
          bollicine.map((piatti) => {

            const { id, titolo, descrizione, prezzo, } = piatti;
            return (
              <>
                <Box>
                  <Typography gutterBottom variant="h6" component="div">
                    {titolo}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {descrizione}
                  </Typography>

                  <Typography inline variant="body1" color="text.secondary" align='right'>
                    {prezzo}€
                  </Typography>


                </Box>
                <Divider />
              </>
            )
          })

        }
      </TabPanel>
      <TabPanel value={value} index={11}>
        <Typography variant="h5" sx={{ fontWeight: "500", marginTop: "15vh", }} gutterBottom component="div">
          {lingua == "it" ? "Distillati" : "Distillati"}

        </Typography>
        <Divider />



        {
          distillati.map((piatti) => {

            const { id, titolo, descrizione, prezzo, } = piatti;
            return (
              <>
                <Box>
                  <Typography gutterBottom variant="h6" component="div">
                    {titolo}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {descrizione}
                  </Typography>

                  <Typography inline variant="body1" color="text.secondary" align='right'>
                    {prezzo}€
                  </Typography>


                </Box>
                <Divider />
              </>
            )
          })

        }
      </TabPanel>
      <Typography gutterBottom variant="h6" component="div" style={{marginTop:40}}>
          Lista Allergeni
        </Typography>

        <Stack direction="column">

          <Stack direction="row" alignItems="center" style={{marginBottom:20}}>
          <img src={'allergeni/grano.png'} style={{ height: 40, width: 40, marginLeft: 5,marginBottom:20 }} />
          <Typography variant="body2" color="text.secondary">
          cereali, grano, segale, orzo, avena, farro, kamut, inclusi ibridati e derivati
                  </Typography>
          </Stack>

          <Stack direction="row" alignItems="center" style={{marginBottom:20}}>
          <img src={'allergeni/crostacei.png'}style={{ height: 40, width: 40, marginLeft: 5,marginBottom:20 }} />
          <Typography variant="body2" color="text.secondary">
          Crostacei e derivati sia quelli marini che d’acqua dolce: gamberi, scampi, aragoste, granchi, paguri e simili
                  </Typography>
          </Stack>

          <Stack direction="row" alignItems="center" style={{marginBottom:20}}>
          <img src={'allergeni/uova.png'}style={{ height: 40, width: 40, marginLeft: 5,marginBottom:20 }} />
          <Typography variant="body2" color="text.secondary">
        	tutti i prodotti composti con uova, anche in parte minima. Tra le più comuni: maionese, frittata, emulsionanti, pasta all’uovo, biscotti e torte anche salate, gelati e creme ecc
                  </Typography>
          </Stack>

          <Stack direction="row" alignItems="center" style={{marginBottom:20}}>
          <img src={'allergeni/pesce.png'}style={{ height: 40, width: 40, marginLeft: 5,marginBottom:20 }} />
          <Typography variant="body2" color="text.secondary">
        	inclusi i derivati, cioè tutti quei prodotti alimentari che si compongono di pesce, anche se in piccole percentuali
                  </Typography>
          </Stack>

          <Stack direction="row" alignItems="center" style={{marginBottom:20}}>
          <img src={'allergeni/arachidi.png'} style={{ height: 40, width: 40, marginLeft: 5,marginBottom:20 }} />
          <Typography variant="body2" color="text.secondary">
          Arachidi e derivati, snack confezionati, creme e condimenti in cui vi sia anche in piccole dosi
                  </Typography>
          </Stack>
         
          <Stack direction="row" alignItems="center" style={{marginBottom:20}}>
          <img src={'allergeni/soia.png'} style={{ height: 40, width: 40, marginLeft: 5,marginBottom:20 }} />
          <Typography variant="body2" color="text.secondary">
          Soia e derivati come, latte, tofu, spaghetti, etc.
                  </Typography>
          </Stack>

          <Stack direction="row" alignItems="center" style={{marginBottom:20}}>
          <img src={'allergeni/latte.png'} style={{ height: 40, width: 40, marginLeft: 5,marginBottom:20 }} />
          <Typography variant="body2" color="text.secondary">
          Latte e derivati	yogurt, biscotti e torte, gelato e creme varie. Ogni prodotto in cui viene usato il latte
                  </Typography>
          </Stack>
         
          <Stack direction="row" alignItems="center" style={{marginBottom:20}}>
          <img src={'allergeni/ghianda.png'} style={{ height: 40, width: 40, marginLeft: 5,marginBottom:20 }} />
          <Typography variant="body2" color="text.secondary">
          Frutta a guscio e derivati	tutti i prodotti che includono: mandorle, nocciole, noci comuni, noci di acagiù, noci pecan e del Brasile e Queensland, pistacchi
                  </Typography>
          </Stack>
      
          <Stack direction="row" alignItems="center" style={{marginBottom:20}}>
          <img src={'allergeni/sedano.png'} style={{ height: 40, width: 40, marginLeft: 5,marginBottom:20 }} />
          <Typography variant="body2" color="text.secondary">
          Sedano e derivati	presente in pezzi ma anche all’interno di preparati per zuppe, salse e concentrati vegetali
                  </Typography>
          </Stack>

          <Stack direction="row" alignItems="center" style={{marginBottom:20}}>
          <img src={'allergeni/senape.png'} style={{ height: 40, width: 40, marginLeft: 5,marginBottom:20 }} />
          <Typography variant="body2" color="text.secondary">
          Senape e derivati	si può trovare nelle salse e nei condimenti, specie nella mostarda
                  </Typography>
          </Stack>

          <Stack direction="row" alignItems="center" style={{marginBottom:20}} >
          <img src={'allergeni/sesamo.png'} style={{ height: 40, width: 40, marginLeft: 5,marginBottom:20 }} />
          <Typography variant="body2" color="text.secondary">
          Semi di sesamo e derivati, oltre ai semi interi usati per il pane, possiamo trovare tracce in alcuni tipi di farine
                  </Typography>
          </Stack>
     
          <Stack direction="row" alignItems="center"  style={{marginBottom:20}}>
          <img src={'allergeni/so2.png'} style={{ height: 40, width: 40, marginLeft: 5,marginBottom:20 }} />
          <Typography variant="body2" color="text.secondary">
          Anidride solforosa e solfiti in concentrazioni superiori a 10 mg/kg o 10 mg/l espressi come SO2	usati come conservanti, possiamo trovarli in: conserve di prodotti ittici, in cibi sott’aceto, sott’olio e in salamoia, nelle marmellate, nell’aceto, nei funghi secchi e nelle bibite analcoliche e succhi di frutta
                  </Typography>
          </Stack>
         
          <Stack direction="row" alignItems="center" style={{marginBottom:20}}>
          <img src={'allergeni/lupini.png'} style={{ height: 40, width: 40, marginLeft: 5,marginBottom:20 }} />
          <Typography variant="body2" color="text.secondary">
          Lupino e derivati, presente ormai in molti cibi vegan, sotto forma di arrosti, salamini, farine e similari che hanno come base questo legume, ricco di proteine
                  </Typography>
          </Stack>
    
          <Stack direction="row" alignItems="center"  style={{marginBottom:20}}>
          <img src={'allergeni/mollusco.png'} style={{ height: 40, width: 40, marginLeft: 5,marginBottom:20 }} />
          <Typography variant="body2" color="text.secondary">
          canestrello, cannolicchio, capasanta, cuore, dattero di mare, fasolaro, garagolo, lumachino, cozza, murice, ostrica, patella, tartufo di mare, tellina e vongola etc.                  </Typography>
          </Stack>
          

        </Stack>

    </Container>
  );
}

export default App;
